var FcButtonModule = /** @class */ (function () {
    function FcButtonModule() {
    }
    return FcButtonModule;
}());
export { FcButtonModule };
